<template>
    <div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>
        <div class="card">
            <div class="flex justify-content-center flex-wrap card-container">
                <div class="flex align-items-center justify-content-center w-14rem h-4rem m-2">
                    <span class="p-float-label">
                        <Calendar v-model="fechaI" dateFormat="dd-MM-yy" />
                        <label>Fecha Inicial</label>
                      </span>
                </div>
                <div class="flex align-items-center justify-content-center w-14rem h-4rem m-2">
                    <span class="p-float-label">
                        <Calendar v-model="fechaF" dateFormat="dd-MM-yy" />
                        <label>Fecha Final</label>
                      </span>
                </div>
                <div class="flex align-items-center justify-content-center w-4rem h-4rem m-2">
                    <div class="field col-4">
                        <Button icon="mdi mdi-text-box-search-outline" class="p-button-text p-button-rounded" @click="Consultar()" v-tooltip.bottom="'Consultar'" style="color:#FBC31F"/>
                    </div>
                </div>
            </div>
            <!-- TABLA DE CONCEPTOS PROPIOS -->
            <DataTable :value="itemConceptosPropios" :scrollable="true" scrollHeight="400px" scrollDirection="both" >
                <template #header>
                    <div class="text-center p-d-flex justify-center p-fluid grid formgrid">
                        <div class="col-12 text-center pa-0 ma-0 pl-3">
                            <h1>Conceptos</h1>
                            <Button icon="mdi mdi-information" class="p-button-text p-button-rounded" @click="OpenNotas(1)" v-tooltip.bottom="'Información'" style="color:#24ACF2"/>
                        </div>
                    </div>
                </template>
                <Column field="clave" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="concepto" header="Concepto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="gravado" header="Gravado" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.gravado) }}</span>
                      </template>
                </Column>
                <Column field="exento" header="Exento" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.exento) }}</span>
                      </template>
                </Column>
                <Column field="deduccion" header="Deducción" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.deduccion) }}</span>
                      </template>
                </Column>
                <Column field="otrosPagos" header="Otros Pagos" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.otrosPagos) }}</span>
                      </template>
                </Column>
            </DataTable>

            <!-- TABLA DE CONCEPTOS SAT -->
            <DataTable :value="itemConceptosSat" :scrollable="true" scrollHeight="400px" scrollDirection="both" >
                <template #header>
                    <div class="text-center p-d-flex justify-center p-fluid grid formgrid">
                        <div class="col-12 text-center pa-0 ma-0 pl-3">
                            <h1>Conceptos SAT</h1>
                            <Button icon="mdi mdi-information" class="p-button-text p-button-rounded" @click="OpenNotas(1)" v-tooltip.bottom="'Información'" style="color:#24ACF2"/>
                        </div>
                    </div>
                </template>
                <Column field="clave" header="Clave" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="concepto" header="Concepto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="gravado" header="Gravado" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.gravado) }}</span>
                      </template>
                </Column>
                <Column field="exento" header="Exento" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.exento) }}</span>
                      </template>
                </Column>
                <Column field="deduccion" header="Deducción" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.deduccion) }}</span>
                      </template>
                </Column>
                <Column field="otrosPagos" header="Otros Pagos" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.otrosPagos) }}</span>
                      </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";

    export default {
        components: {
            
        },
        data() {
            return {
                itemConceptosPropios: [],
                itemConceptosSat: [],
                fechaI: new Date(),
                fechaF: new Date(),

                loading: false,
                loadingMensaje: '',
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            
        },
        created() {

        },
        methods: {
            async Consultar(){
                this.loading = true;
                this.loadingMensaje = 'Consultando, espere...'
                await this.ConsultarPropios();
                await this.ConsultarSat();
                this.loading = false;
            },

            async ConsultarPropios(){
                let fI = moment(this.fechaI).format('YYYY-MM-DD')
                let fF = moment(this.fechaF).format('YYYY-MM-DD')
                try{
                    let response = await axios.get('ReporteNominas/GetReporteConceptos/'+ this.token.empresaBase + '/' + fI + '/' + fF);
                    this.itemConceptosPropios = response.data;
                }catch(error){
                    console.log(error)
                }
            },

            async ConsultarSat(){
                let fI = moment(this.fechaI).format('YYYY-MM-DD')
                let fF = moment(this.fechaF).format('YYYY-MM-DD')
                try{
                    let response = await axios.get('ReporteNominas/GetReporteConceptosSat/'+ this.token.empresaBase + '/' + fI + '/' + fF);
                    this.itemConceptosSat = response.data;
                }catch(error){
                    console.log(error)
                }
            },

            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

        },
    }
</script>